module.exports = __webpack_public_path__ + "img/jhf_fav_bw.15c3a2be.svg";